module.exports = __webpack_public_path__ + "static/media/Template_11.121e02ad.png";